// extracted by mini-css-extract-plugin
export default {"Title":"headingCard_Title__0XUsQ","Wave":"headingCard_Wave__F8zs8","Icon":"headingCard_Icon__Nk74S"};